import { IDSK } from "@examspark/types";

/** Returns [workspace/bank] formatted bankId string. */
export function getBankIdFromData(data: IDSK) {
  const reg = data.sk.match(/bank#(.*)/);
  const bankId = `${data.id}/${reg?.[1]}`;
  return bankId;
}
